<template>
  <div
    class="toast"
    :class="className"
  >
    <!-- Верхняя панель -->
    <div class="toast__header">
      <img
        v-if="icon === 'default'"
        class="toast__icon"
        :src="imagePath('/images/notifications/default.svg')"
        alt="notification"
      />
      <img
        v-if="icon === 'success'"
        class="toast__icon"
        :src="imagePath('/images/notifications/success.svg')"
        alt="notification"
      />
      <img
        v-if="icon === 'warning'"
        class="toast__icon"
        :src="imagePath('/images/notifications/warning.svg')"
        alt="notification"
      />
      <img
        v-if="icon === 'error'"
        class="toast__icon"
        :src="imagePath('/images/notifications/error.svg')"
        alt="notification"
      />
      <h4 v-if="title" class="toast__title">{{ title }}</h4>
      <span v-else>{{ text }}</span>
      <img
        class="toast__icon__close"
        src="/images/notifications/close.svg"
        alt="notification"
        @click="$emit('close')"
      />
    </div>
    
    <!-- Основное содержимое уведомления -->
    <div class="toast__content"
      v-if="title"
    >
      <span v-if="isHtml" v-html="text"></span>
    </div>
    
    <!-- Ползунок затухания -->
    <div 
      v-if="showProgress" 
      class="toast__progress"
    >
      <div 
        class="toast__progress-bar" 
        :style="{ width: progress + '%' }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UIToast',

  props: {
    className: String,
    icon: String,
    title: String,
    text: String,
    isHtml: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: 0
    },
    startTime: {
      type: Number,
      default: null
    },
    duration: {
      type: Number,
      default: null
    }
  },

  emits: ['close'],

  data() {
    return {
      progress: 0,
      progressInterval: null
    };
  },

  computed: {
    showProgress() {
      return this.delay > 0 && this.startTime && this.duration;
    }
  },

  watch: {
    showProgress: {
      handler(newVal) {
        if (newVal) {
          this.startProgress();
        } else {
          this.stopProgress();
        }
      },
      immediate: true
    }
  },

  methods: {
    imagePath(path) {
      return window.location.origin + path;
    },
    
    startProgress() {
      this.stopProgress();
      
      // Устанавливаем начальное значение
      const elapsed = Date.now() - this.startTime;
      this.progress = Math.min(100, (elapsed / this.duration) * 100);
      
      // Запускаем интервал для обновления прогресса
      this.progressInterval = setInterval(() => {
        const elapsed = Date.now() - this.startTime;
        this.progress = Math.min(100, (elapsed / this.duration) * 100);
        
        // Если прогресс достиг 100%, останавливаем интервал
        if (this.progress >= 100) {
          this.stopProgress();
        }
      }, 50); // Для плавности
    },
    
    stopProgress() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      }
    }
  },
  
  beforeUnmount() {
    this.stopProgress();
  }
};
</script>

<style lang="scss" scoped>
@import '@/ManualApp/scss/vars.scss';
.toast {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 18px;
  line-height: 28px;
  width: auto;
  opacity: 1;
}

.toast__header {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 12px;
}

.toast__title {
  flex: 1;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  margin: 0 12px;
}

.toast__icon {
  margin-right: 8px;
  &__close {
    margin-left: 16px;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 0px 2px $txt-primary-color;
    }
  }
}

.toast__content {
  flex: 1;
}

.toast.toast_default {
  color: $txt-primary-color;
  background-color: rgba($default-color, 0.15);
  box-shadow: 0px 4px 8px rgba($default-color, 0.15);
  border: 1px solid $default-color;
}
.toast.toast_success {
  color: $txt-primary-color;
  background-color: rgba($success-color, 0.15);
  box-shadow: 0px 4px 8px rgba($success-color, 0.15);
  border: 1px solid $success-color;
}

.toast.toast_warning {
  color: $txt-primary-color;
  background-color: rgba($warning-color, 0.15);
  box-shadow: 0px 4px 8px rgba($warning-color, 0.15);
  border: 1px solid $warning-color;
}

.toast.toast_error {
  color: $txt-primary-color;
  background-color: rgba($error-color, 0.15);
  box-shadow: 0px 4px 8px rgba($error-color, 0.15);
  border: 1px solid $error-color;
}

.toast :deep(h4) {
  margin-bottom: -20px !important;
}

.toast__progress {
  width: 100%;
  height: 4px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-top: 12px;
  overflow: hidden;
}

.toast__progress-bar {
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  transition: width 0.1s linear;
}
</style>
